/**
 * A list's Area filter in the URL (slice 6d spec §4.4): `?area=<slug>|none`.
 */
import { useSearchParams } from "react-router-dom";
import { areaParam } from "./area-view";

/** The list's `?area=`, and a setter that keeps the rest of the URL. */
export function useAreaFilter() {
  const [params, setParams] = useSearchParams();
  const area = areaParam(params.get("area"));
  const set = (next: string | null) =>
    setParams(
      (p) => {
        const q = new URLSearchParams(p);
        if (next) q.set("area", next);
        else q.delete("area");
        return q;
      },
      { replace: true },
    );
  return [area, set] as const;
}
